var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-body--layers" },
    [
      _c(
        "b-checkbox",
        {
          attrs: { checked: _vm.isAllSelected },
          on: { change: _vm.selectAllHandler },
        },
        [_vm._v("\n    Select All\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.templates, function (template) {
        return _c("FolderLayer", {
          key: template.name,
          attrs: { node: template },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }